module.exports = __webpack_public_path__ + "static/media/users.7bcfc391.svg";